import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import calendarpng from "./../../Asset/New_Assert/ESO_Icon/Filter.svg";
import pdficon from "./../../Asset/PDF.png";
import csvicon from "./../../Asset/CSV.png";
import { interpolateRgb } from "d3-interpolate";
import { color } from "d3-color";
import LiquidFillGauge from "react-liquid-gauge";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import { styled, useTheme } from "@mui/material/styles";
import Pagination from '@mui/material/Pagination';
import MSelect from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useSelector } from "react-redux";
import Loader from "../../CommonLoader";
import { Tooltip } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CommonAlert, { GetuserDatavalue } from "../../../../Commonalert/commonalert";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import DatagridComp from "../../DatagridComp";
import { CommonErrorAlert } from "../../../../Commonalert/commonErrorAlert";
import { Container, Grid } from '@mui/material';


export default function NewLinks(props) {

  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tablecardData, setTableCardData] = useState([]);
  const [LinkUrl, SetLinkUrl] = useState('')
  const esodata = useSelector((state) => state);
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const navigate = useNavigate();
  const ApiToken = esodata.apiauthkey.value;


  useEffect(() => {
    GetuserDatavalue(setOpenCommonAlerts, ApiToken, navigate);
    callUserdataApi();
  }, []);

  const apihandleClose = () => {
    setapiOpen(false);
  };
  const callUserdataApi = async (jobid = "") => {
    setLoading(true);
    setTableLoading(true);
    var JobId = '';
    if (props.RankJob) {
      if (props.RankJob.value) {
        JobId = props.RankJob.value
      }
    }
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_new_lost/?link_type=new&user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${JobId}`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setCardData("");
          SetAutoheightval(true)
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data) {
        if (datavalue?.data?.job_date) {
          setCardData("");
          SetAutoheightval(true)
          props.setjobDate(moment(datavalue.data.job_date).format("MMMM DD,YYYY HH:mm"));
        }
      }
      SetLinkUrl(datavalue?.data?.link_url)
      const dataval = datavalue?.data?.new_links_table?.new_links;
      if (dataval && dataval.length > 0) {
        const newData = dataval.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        setCardData(newData);
        SetAutoheightval(false)
      }
      else {
        setCardData("");
        SetAutoheightval(true)
      }
    } catch (err) {
      console.log('err', err)
      setCardData("");
      SetAutoheightval(true)
    }
    setTableLoading(false);
    setLoading(false);
  };
  const columns = [

    {
      field: "date_found",
      headerName: "Date Found",
      minWidth: 150,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: "Recent referring domains date.",
    },
    {
      field: "title",
      headerName: "Title/Referring page",
      minWidth: 400,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      description: "Referring page's title/Referring page's URL.",
      renderCell: (cardData) => {

        let firstEightLetters = cardData?.row?.referring_page;
        let whoedata = firstEightLetters;

        let baseUrl = cardData?.row?.referring_page.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData?.row?.referring_page.split("/").slice(3).join("/");
        return (
          <div classname="link-dt-left"><span style={{ color: "hsl(38.3deg 100% 56.08%)" }}>{cardData.row.title}</span>
            <br />

            <Tooltip title={cardData?.row?.referring_page}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.referring_page} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    // {
    //   field: "da",
    //   headerName: "DA",
    //   minWidth: 100,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: true,
    //   description: "Domain InLink Rank of the target's root domain.",
    // },
    {
      field: "da",
      headerName: "DA",
      minWidth: 100,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Domain InLink Rank of the target's root domain.",
      renderCell: (cardData) => {
        var sr = cardData.row.da;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: '#0b2033',
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
          />
        );
      },
    },
    // {
    //   field: "pa",
    //   headerName: "PA",
    //   minWidth: 100,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: true,
    //   description: "InLink rank of the target URL.",
    // },
    {
      field: "pa",
      headerName: "PA",
      minWidth: 120,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "InLink rank of the target URL.",
      renderCell: (cardData) => {
        var sr = cardData.row.pa;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: "#0b2033",
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
            }}
          />
        );
      },
    },
    {
      field: "anchor",
      headerName: "Anchor/Target Page",
      minWidth: 400,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      description: "Link anchor text for text links/Destination page's URL.",
      renderCell: (cardData) => {
        let baseUrl = cardData?.row?.target_page?.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData?.row?.target_page?.split("/").slice(3).join("/");
        let baseUrl1 = cardData?.row?.anchor?.split("/").slice(0, 3).join("/") || '' + "/";
        let remaining1 = cardData?.row?.anchor?.split("/").slice(3).join("/") || '';
        return (
          <div classname="link-dt-left"><span style={{ color: "hsl(38.3deg 100% 56.08%)" }}>
            {baseUrl1}<br />
            {remaining1}
          </span>
            <br />
            <Tooltip title={cardData.row.target_page}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.target_page} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "link_type",
      headerName: "Link Type",
      minWidth: 130,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: "Type of backlink.",
    },
    {
      field: "nofollow",
      headerName: "Follow/No Follow",
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: "Number of backlinks marked as nofollow and number of backlinks NOT marked as nofollow.",
    },
    {
      field: "first_seen",
      headerName: "First Seen",
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: "The date when the backlink was discovered and added to the index.",

    },
  ];

  const rows = cardData ?? [];
  useEffect(() => {
    if (props.FilterButtonTriggered === true) {
      callUserdataApi()
      props.SetFilterButtonTriggered(false)
      props.closeModal()
    }

  }, [props])

  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = "rgb(255,174,31)";
  const textfillColor = "rgb(255,255,255)";
  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];

  const handleModelPopUp = () => {
    props.openModal();
  }

  const handleDownlodingCSV = () => {
    props.csvdown();
  }

  const handleDownlodingPDF = () => {
    props.pdfdown();
  }

  return (
    <div >
      {loading === true ? <Loader /> : null}


      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp className="datagrid_custom_scroll"
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0]}
                  tableLoading={tableLoading}
                  handleModelPopUp={handleModelPopUp}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  DownloadShowFile={true}
                  customFilter={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
      {/* <div >
        <DatagridComp
          columns={columns}
          rows={rows}
          autoheightval={autoheightval}
          datagridval={2}
          columnFreezeWidth={[0]}
          tableLoading={tableLoading}
        />

      </div> */}
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }
    </div>
  );
}
